const ROLE_LABELS = {
  admin: 'Administrator',
  chairperson: 'Chairperson',
  chairman: 'Chairman',
  ch: 'Chairman',
  responder: 'Responder',
  mp: 'Member Planning',
  ed: 'Executive Director',
  gm: 'General Manager',
  // no: 'Nodal Officer', // REMOVED: NO role deprecated
};

const toTitleCase = (value) =>
  value
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase());

export const getRoleDisplayName = (role) => {
  if (!role) {
    return 'User';
  }

  const normalized = role.toString().trim().toLowerCase();

  if (!normalized) {
    return 'User';
  }

  if (ROLE_LABELS[normalized]) {
    return ROLE_LABELS[normalized];
  }

  return toTitleCase(role.toString());
};


